export default __webpack_public_path__ + "static/media/fileBlankIcon.65f1242f.svg";